// extracted by mini-css-extract-plugin
export default {"withLayout":"Dashboard_withLayout__Dd5nU","container":"Dashboard_container__vMBf0"};